import { ExecutionResult } from 'graphql'
import * as React from 'react'
import { SIGN_IN_MUTATION } from '../../mutations/SIGN_IN_MUTATION'
import { SignInMutation, SignInMutationVariables } from '../../schema/schemaTypes'
import { apolloClient } from '../../utils/apolloClient'
import { IFormValues, LoginFormView } from './LoginFormView'
import Swal from 'sweetalert2'

// tslint:disable-next-line:no-empty-interface
interface IInputProps { }
interface IChildState { is: null | 'loading' | 'wrongUsernamePassword'
    | 'userExpired' | 'noAdmin' | 'error' | 'success' }

export class LoginFormContainer extends React.PureComponent<IInputProps, IChildState> {
  public state: IChildState = { is: null }

  public componentDidMount() {

    if (localStorage.getItem('autoLogout')) {
      localStorage.removeItem('autoLogout')
      Swal.fire({
        title: '<strong>LOG OUT</strong>',
        html:
          'You have been inactive for 30 minutes and were logged out automatically',
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonText: 'OK',
      })
    }
  }

  public render () {
    return <LoginFormView
      doSignIn={this.doSignIn}
      is={this.state.is}
    />
  }

  private doSignIn = async ({ username, password }: IFormValues) => {

    const expoPushToken = (window as any).expoPushToken || null
    username = username.trim()
    this.setState({ is: 'loading' })
    try {
      const { data }: ExecutionResult<SignInMutation> =
        await apolloClient.mutate<SignInMutation, SignInMutationVariables>({
        mutation: SIGN_IN_MUTATION, variables: { username, password, expoPushToken } }) as any

      if (!data || !data.signIn) {
        return this.setState({ is: 'error' })
      }
      localStorage.setItem('authToken', data.signIn.authToken)
      // @ts-ignore
      if(window.ReactNativeWebView) {
        // @ts-ignore
        window.ReactNativeWebView.postMessage(JSON.stringify({name: 'login', authToken: data.signIn.authToken}), '*')
      }

      if (window.location.search.substr(1).includes('referrer')) {
        const path = window.location.search.substr(1).split('=')[1]
        location.assign(path)
        return
      }

      console.log('isFirstLogin', data.signIn.isFirstLogin)
      
      if (data.signIn.user.userType === 'HEALTHCARE_PROVIDER' ||
          data.signIn.user.userType === 'HOSPITAL_MANAGER'
         ) {
        location.assign('/HCP_Welcome')
      } else if (data.signIn.user.userType === 'PARENT_WEBINFO' || data.signIn.user.userType === 'PARENT_WEBINFO_ES')  {
        if (data.signIn.isFirstLogin) {
          location.assign('/contents/disclaimer-webinfo')
        } else {
          location.assign('/contents/webinfo-01')
        }
      } else if (data.signIn.isFirstLogin) {
        location.assign('/welcome')
      } else {
        location.assign('/')
      }
    } catch (err) {
      console.log(err)
      if (err.message === 'Username or password not correct') {
        return this.setState({ is: 'wrongUsernamePassword' })
      } else if (err.message === 'Sorry, this user is expired') {
        return this.setState({ is: 'userExpired' })
      }
      this.setState({ is: 'error' })
    }
  }
}



// WEBPACK FOOTER //
// ./src/organisms/LoginForm/LoginFormContainer.tsx